export default "__VITE_ASSET__6DomCtg$__"